export enum EvaluationActionTypes {
  GET_EVAL_RUNS = "@@EVALUATION/GET_EVAL_RUNS",
  GET_EVAL_RUNS_SUCCESS = "@@EVALUATION/GET_EVAL_RUNS_SUCCESS",
  GET_EVAL_RUNS_FAILURE = "@@EVALUATION/GET_EVAL_RUNS_FAILURE",

  GET_EVAL_RUN = "@@EVALUATION/GET_EVAL_RUN",
  GET_EVAL_RUN_SUCCESS = "@@EVALUATION/GET_EVAL_RUN_SUCCESS",
  GET_EVAL_RUN_FAILURE = "@@EVALUATION/GET_EVAL_RUN_FAILURE",

  DELETE_EVAL_RUN = "@@EVALUATION/DELETE_EVAL_RUN",
  DELETE_EVAL_RUN_SUCCESS = "@@EVALUATION/DELETE_EVAL_RUN_SUCCESS",
  DELETE_EVAL_RUN_FAILURE = "@@EVALUATION/DELETE_EVAL_RUN_FAILURE",

  RUN_EVAL_FROM_CSV = "@@EVALUATION/RUN_EVAL_FROM_CSV",
  RUN_EVAL_FROM_CSV_SUCCESS = "@@EVALUATION/RUN_EVAL_FROM_CSV_SUCCESS",
  RUN_EVAL_FROM_CSV_FAILURE = "@@EVALUATION/RUN_EVAL_FROM_CSV_FAILURE",

  GET_EVAL_CATEGORIES = "@@EVALUATION/GET_EVAL_CATEGORIES",
  GET_EVAL_CATEGORIES_SUCCESS = "@@EVALUATION/GET_EVAL_CATEGORIES_SUCCESS",
  GET_EVAL_CATEGORIES_FAILURE = "@@EVALUATION/GET_EVAL_CATEGORIES_FAILURE",

  DOWNLOAD_EVAL_TEMPLATE = "@@EVALUATION/DOWNLOAD_EVAL_TEMPLATE",
  DOWNLOAD_EVAL_TEMPLATE_SUCCESS = "@@EVALUATION/DOWNLOAD_EVAL_TEMPLATE_SUCCESS",
  DOWNLOAD_EVAL_TEMPLATE_FAILURE = "@@EVALUATION/DOWNLOAD_EVAL_TEMPLATE_FAILURE",

  SET_EVAL_RUNS_FILTER = "@@EVALUATION/SET_EVAL_RUNS_FILTER",
  CLEAR_EVAL_RUN = "@@EVALUATION/CLEAR_EVAL_RUN",
}
